var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashbackPig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 27C35.1046 27 36 26.1046 36 25C36 23.8954 35.1046 23 34 23C32.8954 23 32 23.8954 32 25C32 26.1046 32.8954 27 34 27Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.5C6.5 15.5 4.5 16.5 4.5 19C4.5 20.933 6.067 22.5 8 22.5H8.296",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.07 12.197C14.034 11.968 14 11.739 14 11.5C14 9.019 16.019 7 18.5 7C20.472 7 22.134 8.283 22.74 10.053C23.159 10.031 23.575 10 24 10C24.627 10 25.246 10.032 25.861 10.079C25.194 6.621 22.149 4 18.5 4C14.364 4 11 7.364 11 11.5C11 12.279 11.12 13.031 11.341 13.738C12.193 13.162 13.111 12.653 14.07 12.197Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 23.5H40.039C39.148 20.545 36.978 17.983 34.011 16.19L34.015 16.185L35.5 9.5C35.5 9.5 30.053 9.516 27.828 13.862V13.867C26.598 13.636 25.32 13.5 24 13.5C14.902 13.5 7.5 19.332 7.5 26.5C7.5 30.124 9.396 33.403 12.443 35.763L11.693 37.779C11.02 39.591 11.943 41.606 13.754 42.279C14.156 42.428 14.568 42.499 14.973 42.499C16.394 42.499 17.73 41.627 18.254 40.218L18.774 38.82C20.419 39.255 22.172 39.5 24 39.5C25.818 39.5 27.564 39.258 29.201 38.828L29.718 40.219C30.242 41.629 31.578 42.5 32.999 42.5C33.404 42.5 33.816 42.429 34.218 42.28C36.03 41.606 36.952 39.592 36.279 37.78L35.535 35.779C37.101 34.57 38.358 33.117 39.219 31.501H42.499C43.051 31.501 43.499 31.053 43.499 30.501V24.501C43.5 23.948 43.052 23.5 42.5 23.5Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbackPig);
export default __webpack_public_path__ + "static/media/cashback-pig.1dc86e6471380c6b0c82ca325b169ecd.svg";
export { ForwardRef as ReactComponent };